<div class="padding-top">
  <ul class="ul-li-view-edit table stripes no-margin border-ul">
    <li class="row" [ngClass]="{'pending-status-bg':pendingStatus}">
      <div id="internal-header" class="col-sm- padding-left"><b>Representative</b></div>
    </li>
    @if (dataSource?.length === 0) {
      <li><div class="col-sm-12"></div></li>
    }
    @for (data of dataSource; track data) {
      <li>
        <div class="col-sm-6" [ngClass]="{'has-error': !data.isComplete}">{{ data.repFirstName }} {{ data.repLastName }} &nbsp;@if (!data.isComplete) {
          <span> - Information Incomplete</span>
        }</div>
        @if (!archivePlanStatus && !isMoneyMgrUser) {
          <div class="col-sm-6">
            <b
              >@if (dataSource && userTypeID === riaUserId && status) {
              <a
                href="javascript:void(0);"
                class="subLink"
                routerLink="representative/edit/{{ data.repId }}"
                >Edit</a
                >
                }&nbsp;@if (dataSource && userTypeID === riaUserId) {
                <span>-</span>
                }&nbsp;
                @if (dataSource && status) {
                  <a
                    href="javascript:void(0);"
                    class="subLink"
                    routerLink="representative/remove/{{ data.repId }}"
                    >
                    Remove From Plan</a
                    >
                    }</b
                    >
                  </div>
                }
              </li>
            }
            @if (!archivePlanStatus && !isMoneyMgrUser && status) {
              <li class="padding-left">
                <b>
                  <a href="javascript:void(0);" class="subLink" routerLink="representative/add">
                    Add @if (numberOfItems > 0) {
                    <span>Another</span>
                    } Representative</a
                    ></b
                    >
                  </li>
                }
              </ul>
            </div>
